import { useTheme } from "@mui/material";
import * as React from "react";

import { RobotoButton } from "@/shared/components/RobotoButton";
import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { isViewableAsImage } from "@/shared/components/visualization/Panel/predicates";
import { AddIcon } from "@/shared/foundation/icons/mui";
import {
  actions,
  ImagePanelState,
  useVizDispatch,
} from "@/shared/state/visualization";

import { DataSourceSelector } from "../../controls/DataSourceSelector";
import styles from "../PlotPanelSettings/AddSeries.module.css";

interface AddImageTopicProps {
  state: ImagePanelState;
}

export function AddImageTopic({ state }: AddImageTopicProps) {
  const vizStateDispatch = useVizDispatch();
  const [isAddingNewTopic, setIsAddingNewTopic] = React.useState(true);

  const theme = useTheme();

  if (isAddingNewTopic) {
    return (
      <>
        <RobotoTypography component={"h3"} className={styles.title}>
          New image topic
        </RobotoTypography>
        <DataSourceSelector
          onChange={(messagePathNode) => {
            vizStateDispatch(
              actions.addClipToImagePanel(
                state.id,
                messagePathNode.toTopicData(),
              ),
            );
            setIsAddingNewTopic(false);
          }}
          optionFilter={isViewableAsImage}
        />
        <div
          className={styles.positionRight}
          style={{ marginTop: theme.spacing(0.5) }}
        >
          <RobotoButton
            eventName={"AddImageTopicCanceled"}
            onClick={() => setIsAddingNewTopic(false)}
            size="small"
          >
            Cancel
          </RobotoButton>
        </div>
      </>
    );
  }

  return (
    <RobotoButton
      eventName={"AddImageTopicClicked"}
      onClick={() => setIsAddingNewTopic(true)}
      startIcon={<AddIcon />}
      size="small"
    >
      Add image topic
    </RobotoButton>
  );
}
